class Etiquetas {
    static get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    listEtiquetas(empresaId, args = {}) {
        const query = gql`
            query ListEtiquetas($empresaId: Int!, $after: String, $before: String, $size: Int, $filter: EtiquetaFilter){
                empresa(id: $empresaId) {
                    id
                    etiquetasPage(filter: $filter, after: $after, before: $before, size: $size){
                        after
                        before
                        entries {
                            ... on Etiqueta {
                                id
                                nome
                                descricao
                                cor
                                insertedAt
                            }
                        }
                    }
                }
            }
        `

        return this.gql
            .query(query, { ...args, empresaId })
            .then(({ empresa: { etiquetasPage } }) => {
                return {
                    etiquetas: etiquetasPage.entries,
                    before: etiquetasPage.before,
                    after: etiquetasPage.after
                }
            })
    }

    createEtiqueta(empresaId, etiquetaParams) {
        const createMutation = gql`
            mutation CreateEtiqueta($empresaId: String!, $etiquetaParams: EtiquetaParams!) {
                empresa(id: $empresaId) {
                    etiqueta: createEtiqueta(empresaId: $empresaId, params: $etiquetaParams) {
                        id
                        nome
                        descricao
                        cor
                    }
                }
            }
        `
        return this.gql
            .mutate(createMutation, { empresaId: empresaId.toString(), etiquetaParams })
            .then(({ empresa: { etiqueta } }) => etiqueta)
    }

    updateEtiqueta(empresaId, etiquetaId, etiquetaParams) {
        const updateMutation = gql`
            mutation UpdateEtiqueta($empresaId: String!, $etiquetaId: String!, $etiquetaParams: EtiquetaParams!) {
                empresa(id: $empresaId) {
                    etiqueta: updateEtiqueta(id: $etiquetaId, params: $etiquetaParams) {
                        id
                        nome
                        descricao
                        cor
                    }
                }
            }
        `

        return this.gql
            .mutate(updateMutation, { empresaId: empresaId.toString(), etiquetaId, etiquetaParams })
            .then(({ empresa: { etiqueta } }) => etiqueta)
    }

    replicateEtiqueta(empresaId, etiqueta, empresas) {
        const replicateMutation = gql`
            mutation ReplicateEtiqueta($empresaId: String!, $etiquetaId: String!, $empresas: [String!]) {
                empresa(id: $empresaId) {
                    etiquetas: replicateEtiqueta(etiquetaId: $etiquetaId, empresasIds: $empresas) {
                        id  
                    }
                }
            }
        `

        return this.gql
            .mutate(replicateMutation, { empresaId: empresaId.toString(), etiquetaId: etiqueta.id, empresas: empresas })
            .then(({ empresa: { etiquetas } }) => etiquetas)
    }

    deleteEtiqueta(empresaId, etiqueta) {
        const query = gql`
            mutation DeleteEtiqueta($empresaId: String!, $etiquetaId: String!) {
                empresa(id: $empresaId) {
                    etiqueta: deleteEtiqueta(id: $etiquetaId) {
                        id
                        nome
                        descricao
                        cor
                    }
                }
            }
        `

        return this.gql
            .mutate(query, { empresaId: empresaId.toString(), etiquetaId: etiqueta.id })
            .then(({ empresa: { etiqueta } }) => etiqueta)

    }

    setNfeEtiquetas(empresaId, nfe, etiquetas) {
        const query = gql`

            mutation SetNfeEtiquetas($empresaId: String!, $nfeId: String!, $etiquetasIds: [String!]) {
                empresa(id: $empresaId) {
                    etiquetas: setNfeEtiquetas(nfeId: $nfeId, etiquetasIds: $etiquetasIds) {
                        id
                        etiqueta {
                            id
                            cor
                            nome
                            descricao
                        }
                    }
                }
            }
        `

        const etiquetasIds = etiquetas.map(e => e.id)

        return this.gql
            .mutate(query, { empresaId: empresaId.toString(), nfeId: nfe.id.toString(), etiquetasIds })
            .then(({ empresa: { etiquetas } }) => etiquetas.map(etiqueta => etiqueta.etiqueta))
    }

    setProdutoEtiquetas(empresaId, { id: produtoId }, etiquetas) {
        const query = gql`
            mutation SetProdutoEtiquetas($empresaId: String!, $produtoId: String!, $etiquetasIds: [String!]) {
                empresa(id: $empresaId) {
                    etiquetas: setProdutoEtiquetas(produtoId: $produtoId, etiquetasIds: $etiquetasIds) {
                        id
                        etiqueta {
                            id
                            cor
                            nome
                            descricao
                        }
                    }
                }
            }
        `

        const etiquetasIds = etiquetas.map(e => e.id)

        return this.gql
            .mutate(query, { empresaId: empresaId.toString(), produtoId, etiquetasIds })
            .then(({ empresa: { etiquetas } }) => etiquetas.map(etiqueta => etiqueta.etiqueta))
    }

    setLoteNfesEtiquetas(empresaId, nfes, etiquetas) {
        const query = gql`
            mutation SetLoteNfesEtiquetas($empresaId: String!, $nfesIds: [String!], $etiquetasIds: [String!]) {
                empresa(id: $empresaId) {
                    etiquetas: setLoteNfesEtiquetas(nfesIds: $nfesIds, etiquetasIds: $etiquetasIds) {
                        id
                        nfe { id }
                        etiqueta {
                            id
                            cor
                            nome
                            descricao
                        }
                    }
                }
            }
        `

        const etiquetasIds = etiquetas.map(e => e.id)
        const nfesIds = nfes.map(n => n.id.toString())

        return this.gql
            .mutate(query, { empresaId: empresaId.toString(), nfesIds, etiquetasIds })
            .then(({ empresa: { etiquetas } }) => etiquetas)
    }

    etiquetasOfNfesBasedOnLote(nfes, loteEtiquetas) {
        const etiquetasIds = new Set(loteEtiquetas.map(e => e.id))
        const etiquetasToRemove = new Set(
            this
                .etiquetasInCommonOnNfes(nfes)
                .reject(inCommon => etiquetasIds.has(inCommon.id))
                .map(e => e.id)
        )

        return nfes.map(nfe => {
            const etiquetas = [...nfe.etiquetas, ...loteEtiquetas]
                .reject(e => etiquetasToRemove.has(e.id))
                .uniqBy(e => e.id)

            return { nfeId: nfe.id, etiquetas }
        })
    }

    etiquetasInCommonOnNfes(nfes) {
        const etiquetasOfNfeGroupById = nfes
            .flatMap(nfe =>
                nfe.etiquetas.map(etiqueta => ({ ...etiqueta, nfeId: nfe.id }))
            )
            .groupBy(etiqueta => etiqueta.id)

        return Object
            .entries(etiquetasOfNfeGroupById)
            .filter(([_id, etiquetas]) => etiquetas.length === nfes.length)
            .flatMap(([_id, etiquetas]) => etiquetas)
            .uniqBy(etiqueta => etiqueta.id)
    }
}

angular
    .module('eficienciaFiscalModule')
    .service('Etiquetas', Etiquetas)
